import { render, staticRenderFns } from "./BindSetting.vue?vue&type=template&id=d8589c50&"
import script from "./BindSetting.vue?vue&type=script&lang=js&"
export * from "./BindSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports